import { useQuery } from "@tanstack/react-query";
import apiClient from "@/apis/client";
import type { ICategory } from "./types";

/**
 * 도메인 미연결 카테고리 조회 응답 인터페이스
 */
interface IGetCategoriesWithoutDomainResponse {
  success: boolean;
  message: string;
  data: ICategory[];
}

/**
 * 도메인 미연결 카테고리 조회 파라미터
 */
interface IGetCategoriesWithoutDomainParams {
  exam_type: string;
  subject: string;
}

/**
 * 도메인 미연결 카테고리 조회 API 함수
 */
const getCategoriesWithoutDomain = async (
  params: IGetCategoriesWithoutDomainParams
): Promise<IGetCategoriesWithoutDomainResponse> => {
  const response = await apiClient.get<IGetCategoriesWithoutDomainResponse>(
    `/categories/without-domain`,
    { params }
  );
  return response.data;
};

/**
 * 도메인 미연결 카테고리 조회 훅
 */
export const useQueryGetCategoriesWithoutDomain = (
  examType: string,
  subject: string
) => {
  return useQuery({
    queryKey: ["categories", "without-domain", examType, subject],
    queryFn: () => getCategoriesWithoutDomain({ exam_type: examType, subject }),
    enabled: !!examType && !!subject,
  });
};
